import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import { AppKey } from '../app/AppKey';
import imageUrls from '../images/imageUrls';
import { getQueryParam } from '../routing/getQueryParam';
import { getWindowLocationHref } from '../routing/getWindowLocationHref';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';
import { setWhichOAuthSelected, updateKeyValue } from '../store/app/action-creators';
import { getIsVerifiedByGoogleCredential } from '../store/app/selectors';
import { clearError } from '../store/error/action-creators';
import { reloadFlow } from '../store/flow/action-creators';
import { isFlow } from '../utils/isFlow';
import { isIntegration } from '../utils/isIntegration';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const ExistingAccountLoginView = () => {
  const {
    redirectToLogin
  } = useLoginRedirect();
  const dispatch = useDispatch();
  const isVerifiedByGoogleCredential = useSelector(getIsVerifiedByGoogleCredential);

  const handleButtonClick = () => {
    let url = getWindowLocationHref();
    const isIntegrationFlow = isFlow(Flow.Integrations);
    const isWordpressIntegration = isIntegration(Integration.Wordpress);
    const isConnectFlow = isFlow(Flow.Connect);
    const loginRedirectUrl = getQueryParam('loginRedirectUrl');

    if (isConnectFlow && loginRedirectUrl) {
      url = loginRedirectUrl;
    }

    const redirectParams = isIntegrationFlow && isWordpressIntegration || isConnectFlow ? {
      redirectUrl: url
    } : {};
    redirectToLogin(redirectParams);
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.OAuthExistingLoginFailed,
    handleButtonClick: handleButtonClick,
    handleLinkClick: () => {
      if (isVerifiedByGoogleCredential) {
        dispatch(reloadFlow());
        dispatch(updateKeyValue(AppKey.IsVerifiedByGoogleCredential, false));
        dispatch(setWhichOAuthSelected(null));
      }

      dispatch(clearError());
    },
    imageURL: imageUrls.door
  });
};

export default ExistingAccountLoginView;